import { withProps } from 'recompose';
import { isActive, isEngageRoute } from '../service';

const withIsPaddingActive = history => withProps({
  isActive: isActive(history) && !isEngageRoute(history),
});

export default withIsPaddingActive;
